import { useRequestSdkStatus } from '../api/useRequestSdkStatus';
import { useMemo } from 'react';
export const useSdkStatus = (lineOfBusiness, clientId) => {
    const statusResult = useRequestSdkStatus(lineOfBusiness, clientId);
    return useMemo(() => {
        if (statusResult.isPending) {
            return { loading: true };
        }
        if (statusResult.isError) {
            return {
                loading: false,
                availabilityStatus: 'unavailable-unknown-reason',
            };
        }
        return {
            loading: false,
            availabilityStatus: statusResult.isAvailable
                ? 'available'
                : 'unavailable-unknown-reason',
        };
    }, [statusResult.isAvailable, statusResult.isError, statusResult.isPending]);
};
//# sourceMappingURL=useSdkStatus.js.map